export function checkInstanceOf(data: any, type: any) {
  return data instanceof type;
}
